import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import HeroSlider from "./components/HeroSlider.jsx";
import Causes from "./components/Causes.jsx";
import Footer from "./components/Footer.jsx";
import Payment from "./components/Payment.jsx";
import AboutUs from "./components/AboutUs.jsx";
import EventsGallery from "./components/Gallery.jsx"
import Podcast from "./components/Podcast.jsx";
import OurTeam  from "./components/OurTeam.jsx";
import Testimonials from "./components/Testimonials.jsx";
import Blog from "./components/Blog.jsx";
const Home = () => (
  <>
    <HeroSlider />
    <AboutUs />
    <Podcast />
    <EventsGallery />
    <OurTeam />
    <Testimonials />
    {/* <Causes /> */}
  </>
);

// const Podcast = () => <h2 style={{ padding: "50px" }}>Youtube Podcast Page</h2>;
// const Blog = () => <h2 style={{ padding: "50px" }}>Blog Page</h2>;
// const OurTeam = () => <h2 style={{ padding: "50px" }}>Our Team Page</h2>;

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/podcast" element={<Podcast />} />
            <Route path="/events" element={<EventsGallery />} />
            <Route path="/causes" element={<Causes />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/payment" element={<Payment />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
